module.exports = __webpack_public_path__ + "img/1440.98b17c49.jpg";